const BASE_URL = "https://krumago-application-assets.s3.us-east-1.amazonaws.com/Retail+Domain+Assets/Avikar/landing_page_banners/";


export const RETAIL = {

    IMAGES: {

        IMAGE_1: `${BASE_URL}banner_two_2.png`,
        IMAGE_2: `${BASE_URL}customized.png`,
        IMAGE_3: `${BASE_URL}header_one.png`,
        IMAGE_4: `${BASE_URL}girl.png.jpg`,
        IMAGE_5: `${BASE_URL}retail-contact-2.jpg`,

    },
};